import type { TourStep } from '@/components/ui/Tour';
import { CLUB_MANAGEMENT_TOUR_STEP_IDS, TOUR_STEP_IDS } from './tour-constants';

function StepContent({ title, description }: { title: string; description: string }) {
  return (
    <div>
      <h3 className="mb-1 font-semibold text-foreground">{title}</h3>
      <p className="text-sm text-muted-foreground">{description}</p>
    </div>
  );
}

/** Dashboard spotlight tour for club-only operators. */
export function getClubOwnerDashboardTourSteps(): TourStep[] {
  return [
    {
      content: (
        <StepContent
          title="Club overview"
          description="Track active members, court hire today, memberships, and courts at a glance."
        />
      ),
      selectorId: TOUR_STEP_IDS.CLUB_BUSINESS_OVERVIEW,
      position: 'bottom',
    },
    {
      content: (
        <StepContent
          title="Today's schedule"
          description="See court hire and facility activity scheduled for today."
        />
      ),
      selectorId: TOUR_STEP_IDS.TODAYS_SCHEDULE,
      position: 'top',
    },
    {
      content: (
        <StepContent
          title="Recent activity"
          description="Stay on top of new bookings, payments, and other club updates."
        />
      ),
      selectorId: TOUR_STEP_IDS.RECENT_ACTIVITY,
      position: 'top',
    },
    {
      content: (
        <StepContent
          title="Facility and club navigation"
          description="Calendar, courts, court hire, members, and inventory are grouped in the sidebar."
        />
      ),
      selectorId: CLUB_MANAGEMENT_TOUR_STEP_IDS.NAV_SECTIONS,
      position: 'right',
    },
    {
      content: (
        <StepContent
          title="Club"
          description="Court hire, memberships, and inventory are grouped in this section of the sidebar."
        />
      ),
      selectorId: CLUB_MANAGEMENT_TOUR_STEP_IDS.CLUB_GROUP,
      position: 'right',
    },
    {
      content: (
        <StepContent
          title="Payments"
          description="Manage Stripe Connect, payouts, tax, and membership discounts from Payments."
        />
      ),
      selectorId: TOUR_STEP_IDS.MANAGE_PAYMENTS,
      position: 'right',
    },
    {
      content: (
        <StepContent
          title="Organization settings"
          description="Update contact details, public branding, and sports offered from Organization."
        />
      ),
      selectorId: CLUB_MANAGEMENT_TOUR_STEP_IDS.ORGANIZATION,
      position: 'right',
    },
    {
      content: (
        <StepContent
          title="Getting started checklist"
          description="Use this checklist to finish core setup — sports, courts, Stripe, and court hire."
        />
      ),
      selectorId: TOUR_STEP_IDS.SETUP_CHECKLIST,
      position: 'top',
    },
  ];
}
